import { Component, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { ProductPage } from 'src/app/assabil-kernel/models/entities/control-tables/product-page';
import { Brand } from 'src/app/assabil-kernel/models/entities/control-tables/brand';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'product-lov',
    templateUrl: './product-lov.component.html',
    styleUrls: ['./product-lov.component.scss']
})


export class ProductLovComponent extends GenericLovComponent {
  
    productCode    : string; 
    includingHold  : boolean;
    salableOnly    : boolean; 
    productPages            : ProductPage[];
    brands                  : Brand[];

    name                    : string;
    productPageCode         : string;
    brandCode               : string;


    products                : Product[] = [];
    sourceProducts          : Product[] = [];
    selectedProducts        : Product[] = [];
    dual                    : boolean = false;
    returnList              : boolean = false;  
    
    
    columns = [
        { prop: 'productCode',  name: 'Code'},
        { prop: 'name',         name: 'Name'}
    ]

    constructor(
        public dialogRef: MatDialogRef<ProductLovComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,
        protected masterDataService : MasterDataService,
        protected toastr            : ToastrService,
        protected router            : Router,
        protected userService       : UserService,
        protected controlService    : ControlTablesService,
        protected location          : Location) {
            super();
            if (data) {
                this.products  = data.products;
                this.dual      = data.dual;
            }
      }

      
    //----------------------------------------------------------------------------------------------------------------
    ngOnInit() {
        this.setData();

        this.controlService.getList("productPage", this.controlService.getRequest()).then(result => { 
            this.productPages = result;   
        });
    
        this.controlService.getList("brand", this.controlService.getRequest()).then(result => { 
            this.brands = result;
        })
    }
    //----------------------------------------------------------------------------------------------------------------

  
   
    //----------------------------------------------------------------------------------------------------------------
    loadData() {
        this.masterDataService.productsGet(this.productCode, this.name, this.productPageCode, this.brandCode, this.salableOnly, this.includingHold).then(result => {
            this.products = result;
            this.setData();
        });
    }
    //----------------------------------------------------------------------------------------------------------------


    //----------------------------------------------------------------------------------------------------------------
    setData() {
        if (! this.products ) return;
        this.sourceProducts  = [...this.products];
    }
   //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    addToSelected(product : Product){
        this.selectedProducts.push(product);
        this.sourceProducts.splice(this.sourceProducts.indexOf(product),1)
        this.sourceProducts   = [...this.sourceProducts]
        this.selectedProducts = [...this.selectedProducts]
    }
    //----------------------------------------------------------------------------------------------------------------
 
    
    //----------------------------------------------------------------------------------------------------------------
    removeFromSelected(product : Product){
        this.sourceProducts.push(product);
        this.selectedProducts.splice(this.selectedProducts.indexOf(product),1)
        this.sourceProducts   = [...this.sourceProducts]
        this.selectedProducts = [...this.selectedProducts]
    }
   //----------------------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------------------------------
    addAll(){
        this.sourceProducts   = [];
        this.selectedProducts = [...this.products];
    }
    removeAll(){
        this.sourceProducts   = [...this.products];
        this.selectedProducts = [];
    }
    //----------------------------------------------------------------------------------------------------------------


    //----------------------------------------------------------------------------------------------------------------    
    closeModal(product : Product){
        if (this.returnList || this.dual) {
            let result = {products : null, product : null, selectedProducts : null};
            result.product             = product;
            result.selectedProducts    = this.selectedProducts;
            result.products            = this.products;
            this.dialogRef.close(result);
        } else {
            this.dialogRef.close(product);
        }
    }
     //----------------------------------------------------------------------------------------------------------------

}
